import workspaceQuery from '../../queries/supplier/PurchasePaymentWorkspaceQuery.graphql';
import listQuery from '../../queries/supplier/PurchasePaymentListQuery.graphql';
import instanceQuery from '../../queries/supplier/PurchasePaymentQuery.graphql';
import defaultQuery from '../../queries/supplier/PurchasePaymentDefault.graphql';
import mutationQuery from '../../mutations/supplier/PurchasePaymentMutation.graphql';
import temporaryMutationQuery from '../../mutations/supplier/SavePurchasePaymentTempMutation.graphql';
import aggregateQuery from '../../queries/supplier/PurchasePaymentAggregateQuery.graphql';
import fragment from '../../fragments/supplier/PurchasePaymentFragment.graphql';
import { DocumentType } from '../../schema/p4types';
import { actions as workspaceActions } from 'actions/supplier/PurchasePaymentWorkspaceAction';
import { EntityType } from '../../../@types/entityTypes';
import { formActionsForPermissions } from '../../../actions/supplier/PurchasePaymentAction';

const PurchasePayment: EntityType = {
  type: 'PurchasePayment',
  title: 'Supplier Payments',
  formTitle: 'Supplier Payment',
  formUrl: '/Suppliers/Payment/Details/',
  workspaceUrl: '/Suppliers/Payment/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporarySave: temporaryMutationQuery,
  documentType: DocumentType.PurchasePayment,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'documentNumber',
  },
  aggregate: aggregateQuery,
  fragment,
  screenReference: 'SUPPLIER_PAYMENT',
  actions: [...formActionsForPermissions, ...workspaceActions],
  readOnlyStatus: [
    {
      key: 'documentStatus',
      status: ['POSTED'],
    },
  ],
};

export default PurchasePayment;
